module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/angle-double-down-2b2df16cf8dc9356687a9e6a0fe1f430.svg";